<template>
  <div class="si-navbar shadow">
    <b-container>
      <b-navbar toggleable="*" type="dark" variant="primary">
        <b-navbar-brand :to="{ name: 'Home' }">Shark Investing</b-navbar-brand>
        <b-navbar-nav>
          <transition name="fade">
            <b-button
              :to="{ name: 'MessageAdd' }"
              v-show="postButton"
              size="sm"
              variant="outline-light"
            >
              Post a message</b-button
            >
          </transition>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown
            class="mx-3"
            no-caret
            right
            title="Show user menu"
          >
            <template #button-content>
              <b-icon icon="person-circle" font-scale="2" />
            </template>
            <b-dropdown-item
              href="/WebAdmin/"
              target="_blank"
              variant="info"
              v-if="isMod"
              >Manage Site
              <b-icon
                class="pl-1"
                font-scale="1"
                title="Opens in a new window/tab"
                icon="box-arrow-up-right"
            /></b-dropdown-item>
            <b-dropdown-item href="/Members/MyAccount.aspx" target="_blank"
              >My Account
              <b-icon
                class="pl-1"
                font-scale="1"
                title="Opens in a new window/tab"
                icon="box-arrow-up-right"
            /></b-dropdown-item>
            <b-dropdown-item :to="{ name: 'Settings' }"
              >My Settings</b-dropdown-item
            >
            <b-dropdown-item @click.prevent="onLogout" variant="danger"
              >Logout</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
        <b-navbar-toggle target="sidebar-1" title="Show main menu" />
      </b-navbar>
      <b-sidebar id="sidebar-1" backdrop right shadow>
        <div class="px-3 py-2">
          <nav class="nav flex-column">
            <router-link
              v-for="category in categoryLinks"
              :key="category.id"
              class="nav-link"
              :to="category.route"
              >{{ category.name }}</router-link
            >
            <div class="dropdown-divider"></div>
            <a
              v-for="category in categoryArchiveLinks"
              :key="category.id + 'archive'"
              class="nav-link text-secondary"
              :href="category.archiveUrl"
              target="_blank"
              >{{ category.name }} Archive
              <b-icon
                class="pl-1"
                font-scale="1"
                title="Opens in a new window/tab"
                icon="box-arrow-up-right"
            /></a>
            <div class="dropdown-divider"></div>
            <a class="nav-link" href="/subscriptions.aspx" target="_blank"
              >Subscriptions
              <b-icon
                class="pl-1"
                font-scale="1"
                title="Opens in a new window/tab"
                icon="box-arrow-up-right"
            /></a>
            <a
              class="nav-link"
              href="http://www.sharkbiotech.com/"
              target="_blank"
              >Shark Biotech
              <b-icon
                class="pl-1"
                font-scale="1"
                title="Opens in a new window/tab"
                icon="box-arrow-up-right"
            /></a>
          </nav>
        </div>
      </b-sidebar>
    </b-container>
  </div>
</template>

<script>
import postCategory from "@/services/postCategory.js";

export default {
  name: "Navbar",
  data: () => ({
    isMod: false,
  }),
  computed: {
    categoryLinks() {
      return postCategory.categoryLinks();
    },
    categoryArchiveLinks() {
      return postCategory.categoryArchiveLinks();
    },
    postButton() {
      return this.$store.getters.postButton;
    },
  },
  methods: {
    onLogout() {
      this.$store.dispatch("logout").then(() => {
        window.location = "/login.aspx";
      });
    },
  },
  mounted() {
    this.$store.dispatch("fetchMember").then((member) => {
      this.isMod = member.isMod;
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_colors";

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.si-navbar {
  background-color: $primary;
  position: sticky;
  top: 0;
  z-index: 1099;

  .fade-enter-active {
    animation: fadeIn 0.5s;
  }

  .fade-leave-active {
    animation: fadeOut 0.5s;
  }

  .navbar-nav {
    .dropdown-menu {
      position: absolute;
    }
  }
}
</style>
